import React, { Component } from "react";
import styles from "./searchAddressControl.module.scss";
import { withGeocoder } from "../../../shared/containers/containerGeocoder";
import GeocoderSearch from "../../Geocoders/GeocoderSearch";
import { withMapControl } from "../../../shared/containers/containerMapControl";

class SearchAddressControl extends Component {
  onSelectResult(selectResult) {
    const { onSetZoom, onSetSearchLocation, onSetGeocoderSearchData, onSetMapCenter } = this.props;

    onSetSearchLocation({ lat: selectResult.lat, lon: selectResult.lon });
    onSetMapCenter({ lat: selectResult.lat, lng: selectResult.lon });
    onSetGeocoderSearchData(selectResult.displayName);
    onSetZoom(13);
  }

  render() {
    return (
      <div className={styles.searchAddressControlContainer}>
        <GeocoderSearch onHadleSelectSearchResult={this.onSelectResult.bind(this)} />
      </div>
    );
  }
}

export default withMapControl(withGeocoder(React.memo(SearchAddressControl)));
